module.exports = __webpack_public_path__ + "img/zdgl_charact_1.90bd5f09.svg";